<template>
	<page-with-aside :hasFooter="true">
		<header class="page-header">
			<nav>
				<router-link to="/about" class="button">About the Program</router-link>
			</nav>
		</header>

		<template #content>
			<section class="content-header">
				<h2>Login</h2>
			</section>

			<section class="content">
				<form class="account form-group" ref="form" @submit="handleSubmit">

					<label class="col-md-4 control-label" for="email">Email Address</label>
					<input id="email" name="email" type="email" placeholder="you@example.com" class="form-control input-md" >

					<label class="col-md-4 control-label" for="password">Password</label>
					<input id="password" name="password" type="password" placeholder="Type your password"
						class="form-control input-md" >
					<label class="col-md-12 control-label" style="width: 100%; color: red;">{{errors[errors.length - 1]}}</label>
					<button type="submit">Login</button>
				</form>
			</section>


		</template>
	</page-with-aside>
</template>
<!-- this page isn't used. login now exists on django side -->

<style scoped lang="scss">
.account {
	max-width: 400px;
}

.form-group {
	display: flex;
	flex-wrap: wrap;

	label {
		display: flex;
		align-content: flex-start;
		padding-right: 2rem;

		input {
			margin: 0 1rem 0 0;
			flex: initial;
		}

		input[type="radio"],
		input[type="checkbox"] {
			width: auto;
			margin-right: .5rem;
		}
	}

	@media (max-width:800px) {

		.radio,
		.checkbox {
			flex-basis: 100%;
		}
	}
}

input[type="submit"] {
	width: auto;
}
</style>

<script>
import PageWithAside from "@/components/PageWithAside.vue";
import { axios } from "@/main.js";

export default {
	name: "Login",
	components: {
		PageWithAside,
	},
	data() {
		return {
			errors: []
		};
	},
	methods: {
		goToChat() {
			this.$router.push('/chat/situation/new/');
			this.changeMode("chat");
		},
		handleSubmit(event) {
			event.preventDefault();
			this.sendLogin();
		},

		sendLogin() {
			let formData = new FormData(this.$refs.form);
			let self = this;
			
			if (!formData.get("email")) {
				this.errors.push("Please enter your username");
				console.log('Please enter your username')
				return;
			}else if (!formData.get("password")) {
				this.errors.push("Please enter your password");
				console.log('Please enter your password')
				return;
			}else{
				this.errors.push("");
			}
			

			formData.set("password", formData.get("password"));

			let url = "/api/authenticate/";
			axios
				.post(url, formData)
				.then(function (response) {
					let status = response.status;

					switch (status) {
						case 200:

							let url = window.location.origin + '/#/profile'	
							window.location = url

							break;

						default:
							break;
					}
				})
				.catch(function (error) {
					let status = error.response.status;
					self.errors.push[error.response.statusText];
					switch (status) {
						case 400:

							self.errors = error.response.data;
							console.log('self.errors', self.errors)

							break;
						case 403:
						self.errors.push(error.response.data.detail)
						default:
							break;
					}
				});
		},


	}
};
</script>